export default __webpack_public_path__ + "static/media/thor-picture.12e71bce.png";